// React dependencies
import React, { useState } from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import MText from '../../../components/Common/MText';
import { IsEmpty } from '../../../common/util';
import { IsValidUrl } from '../../../common/checks';
import Colours from '../../../styles/colours';
import MTextField from '../../../components/MTextField';
import SocialLinksModal from './SocialLinksModal';

const SocialLinkInput = (props) => {
  const [openViewLinksModal, setOpenViewLinksModal] = useState(false);

  return (
    <div>
      <div className="d-flex align-items-baseline" style={{ columnGap: 12 }}>
        <MText
          className="mr-3"
          variant="body2"
          colour={Colours.Gray}
          size={13}
          text={props.title}
        />
      </div>

      <MTextField
        className="w-100 mt-1"
        multiline
        minRows={2}
        maxRows={3}
        value={props.link}
        onChange={props.onChange}
        variant="outlined"
        size="small"
        inputProps={{
          style: {
            fontSize: 12,
          },
        }}
        fullWidth
      />
      {
        !IsEmpty(props.link) && !IsValidUrl(props.link)
      && <MText className="ml-2" text="Link must be a valid url and starts with https" size={10} />
      }

      <SocialLinksModal
        title={props.modalTitle}
        link={props.link || ''}
        onClose={() => setOpenViewLinksModal(false)}
        open={openViewLinksModal}
      />
    </div>
  );
};

SocialLinkInput.defaultProps = {
  modalTitle: '',
};

SocialLinkInput.propTypes = {
  title:      PropTypes.string.isRequired,
  link:       PropTypes.string.isRequired,
  onChange:   PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
};

export default SocialLinkInput;
